/**
 * Environment and impersonation banners (docs/04 §3, docs/07, docs/01 §6).
 * In-flow and stackable — they push content down rather than covering it.
 */

import { FlaskConical, UserSearch } from 'lucide-react';
import type { ReactNode } from 'react';

export function TestEnvBanner({ lastRefresh }: { readonly lastRefresh?: string }): ReactNode {
  return (
    <div
      role="status"
      className="flex items-center gap-2.5 bg-env-test px-4 py-2 text-meta font-semibold text-env-test-text"
    >
      <FlaskConical size={16} aria-hidden />
      <span>Test environment</span>
      {lastRefresh !== undefined ? (
        <span className="font-normal">Data refreshed {lastRefresh}</span>
      ) : null}
    </div>
  );
}

export function ImpersonationBanner({
  targetName,
  expiresIn,
  onEnd,
}: {
  readonly targetName: string;
  readonly expiresIn: string;
  readonly onEnd: () => void;
}): ReactNode {
  return (
    <div
      role="status"
      className="flex items-center gap-2.5 bg-imp px-4 py-2 text-meta font-semibold text-imp-text"
    >
      <UserSearch size={16} aria-hidden />
      <span>
        Viewing as {targetName} — read-only, ends in {expiresIn}
      </span>
      <button
        type="button"
        onClick={onEnd}
        className="ml-auto min-h-6 rounded-ctl border border-current px-2 text-chip font-semibold"
      >
        End now
      </button>
    </div>
  );
}
